import React from 'react';
import { PlayerName, number, ratio } from 'yankees-react-utils';
import { useTranslation } from 'react-i18next';
import { Stats, useCachedOktaQuery } from '../../../data';

const Header = ({ levelId, isLhp, split, batter }) => {
    const { t: translate } = useTranslation();

    const { data: levelAverage, isLoading: isLoadingLevelAverage } = useCachedOktaQuery(
        ['currentLevelAverage', levelId],
        (t) => Stats.currentLevelAvgs(t, levelId),
    );

    return (
        <div className="mx-1">
            <h2>
                <PlayerName player={batter} bats={batter.Bats} />&nbsp;
                {translate('baseball.abbr-versus')}&nbsp;
                {isLhp ? 'LHP' : 'RHP'}
            </h2>
            {split && !isLoadingLevelAverage && (
                <div className="header-wrapper text-uppercase">
                    {translate('sections.reports.pitcher.abbr-strikeout-pct')}: {number(100 * ratio(split.So, split.Pa), 0)}%
                    {levelAverage?.length
                        ? ` (${levelAverage[0].Level.Abbr} ${translate('common.abbr-average')} 
                                ${levelAverage?.length ? number(100 * ratio(levelAverage[0].So, levelAverage[0].Pa), 0) : ''}%)`
                        : ''}
                    <span className="mx-2 header-divider">|</span>
                    {translate('baseball.abbr-walk-ubb-perc')}: {number(100 * ratio(split.Ubb, split.Pa), 0)}%
                    {levelAverage?.length
                        ? ` (${levelAverage[0].Level.Abbr} ${translate('common.abbr-average')} 
                                ${levelAverage?.length ? number(100 * ratio(levelAverage[0].Ubb, levelAverage[0].Pa), 0) : ''}%)`
                        : ''}
                </div>
            )}
        </div>
    );
};

export default Header;
